import { motion } from "framer-motion";
import { Reveal } from "@/components/Reveal";
import { ScaleReveal } from "@/components/ScaleReveal";

export default function Interlude() {
  return (
    <section
      data-testid="interlude-section"
      className="px-6 py-32 md:px-12 md:py-48 lg:px-20"
    >
      <div className="mx-auto max-w-5xl">
        <ScaleReveal>
          <h2 className="font-serif text-4xl leading-[1.12] sm:text-5xl lg:text-7xl">
            Pero decir que sé hacerlo{" "}
            <span className="relative inline-block whitespace-nowrap">
              <span className="text-mirian-wine/35">sería demasiado fácil</span>
              <motion.span
                aria-hidden="true"
                className="absolute left-0 top-1/2 h-[3px] w-full origin-left bg-mirian-lime"
                initial={{ scaleX: 0 }}
                whileInView={{ scaleX: 1 }}
                viewport={{ once: true, margin: "-30% 0px" }}
                transition={{ duration: 0.8, delay: 0.5, ease: [0.22, 1, 0.36, 1] }}
              />
            </span>
            .
          </h2>
        </ScaleReveal>
        <Reveal delay={0.35}>
          <p className="mt-12 max-w-md text-base text-mirian-wine/70 md:mt-16 md:text-lg">
            Así que me permití{" "}
            <em className="font-serif">una pequeña mirada</em>.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
